import { useTranslation } from 'react-i18next';
import { PropertyListingPage } from '@/components/property/PropertyListingPage';
import { SEOHead } from '@/components/SEOHead';

export default function Buy() {
  const { t } = useTranslation();
  return (
    <>
      <SEOHead
        title="Properties for Sale in Ethiopia — Houses, Apartments & Villas"
        description="Browse thousands of properties for sale in Addis Ababa, Adama, Hawassa and across Ethiopia. Find houses, apartments, villas and condos at the best prices."
        canonical="/buy"
      />
      <PropertyListingPage listingType="sale" titleKey={`${t('nav.buy')} — Properties for Sale`} />
    </>
  );
}
